import {} from "../../../constants/icons";

function SearchCourseList(props) {
  const {
    imageSrc,
    bundleIcon,
    title,
    currentPrice,
    originalPrice,
    memberPrice,
    bundleText,
    priceShowLabel,
    itemType,
    itemCourseCount,
  } = props;
  return (
    <div className={`search-course-list ${props.className || ""}`}>
      <div className="search-course-wrap">
        <div className="img-wrap">
          {imageSrc && (
            <img src={imageSrc} className="img-fluid" alt="Course" />
          )}
        </div>
        {itemType == "bundle" && itemCourseCount && (
          <div className="course-bundle-tag">
            <span>{bundleIcon}</span>
            <span>{`${itemCourseCount} in 1`}</span>
          </div>
        )}
      </div>
      <div className="search-course-list-block">
        <div className="notification-heading mk-bell-notification-heading">
          {title && <h2 title={title}>{title}</h2>}
          {priceShowLabel && priceShowLabel == "1" && (
            <div className="course-price-wrapper">
              <div className="pricing-slot pricing-left">
                <span>Current Price</span>
                {currentPrice && (
                  <div className="price">
                    {currentPrice}{" "}
                    {(originalPrice && originalPrice >=0) && (
                      <>
                        <del>{originalPrice}</del>
                      </>
                    )}
                  </div>
                )}
              </div>
              <span className="separator-price-set"></span>
              <div className="pricing-slot pricing-right">
                <span>Member Price</span>
                {memberPrice && <div className="price">{memberPrice}</div>}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchCourseList;
